import React, { createContext, useContext, useState, useEffect } from 'react';

type JoinCodeProps = {
  joinCode?: string;
};

const JoinCodeContext = createContext<string | undefined>(undefined);

export const JoinCodeContextProvider: React.FC<JoinCodeProps> = ({ children, joinCode }) => {
  const [joinCodeState, setJoinCodeState] = useState<string>();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      if (joinCode) {
        window.localStorage.setItem('joinCodeValue', joinCode);
        if (joinCode !== joinCodeState) {
          setJoinCodeState(joinCode);
        }
      } else {
        const joinCodeStorageValue = window.localStorage.getItem('joinCodeValue');
        if (joinCodeStorageValue && joinCodeStorageValue !== joinCodeState) {
          setJoinCodeState(joinCodeStorageValue);
        }
      }
    }
  }, [joinCode, joinCodeState]);

  return <JoinCodeContext.Provider value={joinCodeState}>{children}</JoinCodeContext.Provider>;
};

export const useJoinCode = () => {
  const context = useContext(JoinCodeContext);
  return context;
};
